var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeveloperCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.4 18.2",
    style: {
      enableBackground: "new 0 0 22.4 18.2"
    },
    xmlSpace: "preserve",
    width: "20px",
    height: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#020202;}\n\t.st1{clip-path:url(#SVGID_00000091729446926694886310000002740980777004643997_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#092540;}\n\t.st3{fill:#20201F;}\n\t.st4{fill:none;stroke:#020202;stroke-width:1.3871;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#20201F;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#20201F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#20201F;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,18.2H0V0h22.4V18.2z M1.4,16.9h19.7V1.4H1.4V16.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,3.5c-0.2,0-0.4-0.1-0.5-0.2C2.2,3.1,2.1,3,2.1,2.8s0.1-0.4,0.2-0.5c0.3-0.3,0.7-0.3,1,0 c0.1,0.1,0.2,0.3,0.2,0.5S3.4,3.1,3.3,3.3C3.1,3.4,3,3.5,2.8,3.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,3.5c-0.2,0-0.4-0.1-0.5-0.2C4.3,3.1,4.2,3,4.2,2.8s0.1-0.4,0.2-0.5c0.1-0.1,0.1-0.1,0.2-0.1 c0.3-0.1,0.6,0,0.7,0.1c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5C5.3,3.4,5.1,3.5,4.9,3.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,3.5c-0.2,0-0.4-0.1-0.5-0.2C6.4,3.1,6.3,3,6.3,2.8s0.1-0.4,0.2-0.5c0.3-0.3,0.7-0.3,1,0 c0.1,0.1,0.2,0.3,0.2,0.5S7.6,3.1,7.5,3.3C7.4,3.4,7.2,3.5,7,3.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,5.6H0.7C0.3,5.6,0,5.3,0,4.9s0.3-0.7,0.7-0.7h21.1c0.4,0,0.7,0.3,0.7,0.7S22.1,5.6,21.8,5.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,14.7c-0.2,0-0.3-0.1-0.4-0.2c-0.3-0.2-0.3-0.7-0.1-1l2.1-2.4l-2.1-2.4c-0.2-0.3-0.2-0.7,0.1-1 c0.3-0.2,0.7-0.2,1,0.1l2.9,3.3L16,14.5C15.8,14.6,15.6,14.7,15.4,14.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,14.7c-0.2,0-0.4-0.1-0.5-0.2l-2.9-3.3L6.5,8c0.2-0.3,0.7-0.3,1-0.1c0.3,0.2,0.3,0.7,0.1,1l-2.1,2.4 l2.1,2.4c0.2,0.3,0.2,0.7-0.1,1C7.3,14.7,7.2,14.7,7,14.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,15.4c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.5-0.5-0.4-0.9l2.8-7c0.1-0.4,0.5-0.5,0.9-0.4 c0.4,0.1,0.5,0.5,0.4,0.9l-2.8,7C10.3,15.3,10.1,15.4,9.8,15.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperCenter);
export default __webpack_public_path__ + "static/media/developer-center.0a3bb14b.svg";
export { ForwardRef as ReactComponent };